const authorList = document.querySelectorAll(".author-name ");
let activeIndex = 0;
window.addEventListener('load', () => {
  const imageContainer = document.querySelector(".author-testimonial__image.slide-show__container");
  const quoteContainer = document.querySelector(".author-testimonial__info-container.slide-show__container");
  setElementHeight(imageContainer, imageContainer.children[activeIndex]);
  setElementHeight(quoteContainer, quoteContainer.children[activeIndex]);
})

authorList.forEach((author, index) => {
  author.addEventListener('click', () => {
    activeIndex = parseInt(author.getAttribute('author-index'));
    const activeAuthorEls = document.querySelectorAll('.author-active');
    author.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
    activeAuthorEls.forEach((activeEl) => activeEl.classList.remove('author-active'));
    activateElements(activeIndex);
  })
})

const activateElements = (activeIndex) => {
  const slideShowContainer = document.querySelectorAll('.slide-show__container');
  slideShowContainer.forEach(containerEl => {
    containerEl.children[activeIndex].classList.add("author-active");
    setElementHeight(containerEl, containerEl.children[activeIndex]);
  })
}

const setElementHeight = (container, child) => {
  container.style.height = child.offsetHeight + 'px';
}
